/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { environmentsUpdateBySlug } from "../funcs/environmentsUpdateBySlug.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Environment } from "../models/components/environment.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateEnvironmentRequest,
  UpdateEnvironmentSecurity,
} from "../models/operations/updateenvironment.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateEnvironmentMutationVariables = {
  request: UpdateEnvironmentRequest;
  security?: UpdateEnvironmentSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateEnvironmentMutationData = Environment;

export type UpdateEnvironmentMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateEnvironment environments
 *
 * @remarks
 * Update an environment
 */
export function useUpdateEnvironmentMutation(
  options?: MutationHookOptions<
    UpdateEnvironmentMutationData,
    UpdateEnvironmentMutationError,
    UpdateEnvironmentMutationVariables
  >,
): UseMutationResult<
  UpdateEnvironmentMutationData,
  UpdateEnvironmentMutationError,
  UpdateEnvironmentMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateEnvironmentMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateEnvironment(): MutationKey {
  return ["@gram/client", "environments", "updateBySlug"];
}

export function buildUpdateEnvironmentMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateEnvironmentMutationVariables,
  ) => Promise<UpdateEnvironmentMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateEnvironment(),
    mutationFn: function updateEnvironmentMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateEnvironmentMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(environmentsUpdateBySlug(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
